/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { ProtocolSectionArgs } from "../../base-components/base-protocol-item";
export default class TreatmentHistoryDefaultOtherFollowUpEventsComponent extends Component {
  get otherTypes() {
    return ["announcement-consultation", "sentinel-node-lymphoscinthigraphy", "ultrasound-spotting", "anaesthetist-consultation", "abdominal-ultrasound", "echocardiography", "mri", "mammography", "preoperative-nurse-appointment", "scanner", "tracking-scanner", "bone-scan", "computed-tomography", "addictologist", "respiratory-cine", "dentist", "psychologist", "social-worker"];
  }
}